import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/viz-gaz-futes/00001.jpg'
import i00002 from '../images/viz-gaz-futes/00002.jpg'
import i00003 from '../images/viz-gaz-futes/00003.jpg'
import i00004 from '../images/viz-gaz-futes/00004.jpg'
import i00005 from '../images/viz-gaz-futes/00005.jpg'
import i00006 from '../images/viz-gaz-futes/00006.jpg'
import i00007 from '../images/viz-gaz-futes/00007.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,
    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <SubTitle>Vízszerelés</SubTitle>
        <p>
          Cégünk víz-, gáz-, fűtésszereléssel is foglalkozik, közintézmények, társasházak, családi házak, lakások
          rendszereinek kiépítését, felújítását, fűtéskorszerűsítését, radiátorcserét, illetve padlófűtés kialakítását
          vállalja. Munkáink során az adott feladat elvégzéséhez szükséges, korszerű szerszámokkal, gépekkel,
          anyagokkal, szakember gárdával várjuk, megtisztelő megrendelését!
        </p>
      </Section>
      <Section>
        <SubTitle>Vízszerelés</SubTitle>
        <ul>
          <li>Komplett fürdőszoba kiépítése, felújítása a szükséges bontásokkal együtt </li>
          <li>
            Szaniterek cseréje, szerelvényezése: kád, zuhanytálca, mosdó, zuhanykabin, bidé, WC csésze és tartály
            bekötése; csapok, csaptelepek cseréje.{' '}
          </li>
          <li>Mosógépek, mosogatók, mosogatógépek bekötése. </li>
          <li>Beázások megszüntetése, elöregedett lefolyóvezetékek cseréje. </li>
          <li>Vízóraszerelés </li>
        </ul>
      </Section>
      <Section>
        <SubTitle>Gázszerelés</SubTitle>
        <ul>
          <li>Új gázvezeték rendszerek kiépítése, meglévő rendszerek átalakítása műszaki átadással. </li>
          <li>Cirkók, gázkészülékek, konvektorok, bojlerek, gázkazánok javítása, cseréje, beépítése. </li>
          <li>Gázkészülékek téli, fűtési szezonra való felkészítése, tisztítása, ellenőrzése. </li>
          <li>Gázszivárgás keresés gázdetektorral.</li>
        </ul>
      </Section>
      <Section>
        <SubTitle>Fűtésszerelés</SubTitle>
        <ul>
          <li>Radiátoros, padlótfűtési rendszerek kialakítása </li>
          <li>Családi házak, lakások fűtési rendszerének kiépítése, korszerűsítése, felújítása. </li>
          <li>Radiátorok, radiátor szelepek cseréje anyagbeszerzéssel. </li>
          <li>Központi fűtés rendszer tervezése, kivitelezése, légtelenítése, beszabályozása. </li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          {/* <img src={i00002} alt="" /> */}
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
